class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('.search-modal__close-button');
    this.isHeaderSearch = this.classList.contains('header__search') && Boolean(this.closeButton);
    this.onViewportChange = this.setHeaderSearchCloseButtonPosition.bind(this);

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    if (this.isHeaderSearch) {
      window.addEventListener('resize', this.onViewportChange);
      requestAnimationFrame(this.onViewportChange);
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (this.isHeaderSearch) {
      window.removeEventListener('resize', this.onViewportChange);
      this.style.removeProperty('--header-search-close-top');
      this.style.removeProperty('--header-search-close-left');
      this.style.removeProperty('--header-search-close-width');
      this.style.removeProperty('--header-search-close-height');
      this.style.removeProperty('--header-search-close-offset');
    }
  }

  disconnectedCallback() {
    if (this.isHeaderSearch) {
      window.removeEventListener('resize', this.onViewportChange);
    }
  }

  setHeaderSearchCloseButtonPosition() {
    if (!this.isHeaderSearch || !this.isOpen()) return;

    const toggleRect = this.summaryToggle.getBoundingClientRect();
    this.style.setProperty('--header-search-close-top', `${toggleRect.top}px`);
    this.style.setProperty('--header-search-close-left', `${toggleRect.left}px`);
    this.style.setProperty('--header-search-close-width', `${toggleRect.width}px`);
    this.style.setProperty('--header-search-close-height', `${toggleRect.height}px`);
    this.style.setProperty('--header-search-close-offset', `${window.innerWidth - toggleRect.left}px`);
  }
}

customElements.define('details-modal', DetailsModal);
